
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wing/features",
      function () {
        return require("private-next-pages/wing/features/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wing/features"])
      });
    }
  